import React from 'react';

import _ from 'lodash';

import PropTypes from 'prop-types';

import { getPdfUrl } from '../../utils/utils';
import { useLocaleContext } from '../../context/LocaleContext';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { ButtonLink } from './css';

const DownloadQuotePdf = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const locale = useLocaleContext();
  const {
    srtDashboard: { saveQuote }
  } = localizedStrings;

  return (
    <ButtonLink
      className="download-link action-button"
      href={getPdfUrl(_.get(orderData, 'id', ''), locale)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {saveQuote}
    </ButtonLink>
  );
};

DownloadQuotePdf.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default DownloadQuotePdf;
